import Vue from "vue";

import CodeMirror from "codemirror";
import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/addon/hint/show-hint";
import "codemirror/addon/mode/simple";

import optionsTree from "./HighchartsOptions.json";
import debounce from "../../assets/js/debounce";
const chart = function() {
  CodeMirror.defineSimpleMode("dotenotation", {
    // The start state contains the rules that are initially used
    start: [
      { regex: /([a-z.])+/i, token: "attribute" },
      { regex: /=/, token: "operator", next: "value" }
    ],
    value: [{ regex: /[a-z0-9().,]+/i, token: "string", next: "start" }]
  });

  Vue.directive("chart-options-editor", {
    inserted: function(el) {
      const options = {
        lineNumbers: true,
        foldGutter: true,
        mode: "dotenotation",
        gutters: ["CodeMirror-linenumbers"]
      };

      CodeMirror.registerHelper("hint", "highChartsHint", function(editor) {
        const cursor = editor.getCursor();

        const pathSeparator = ".";
        const curLine = editor.getLine(cursor.line);
        let start = cursor.ch;
        let end = start;
        const tokenType = editor.getTokenTypeAt(
          CodeMirror.Pos(cursor.line, start)
        );
        let list = [];

        if (tokenType === "attribute") {
          while (end < curLine.length && /[\w$]/.test(curLine.charAt(end))) {
            ++end;
          }

          while (start && /[\w$]/.test(curLine.charAt(start - 1))) {
            --start;
          }

          const curWord = start !== end && curLine.slice(start, end);
          const regex = new RegExp("^" + curWord, "i");
          const path = curLine.slice(0, start);

          let arrayPath = path.trim(pathSeparator).split(pathSeparator);
          arrayPath = arrayPath.filter(chunk => {
            return chunk.length > 0;
          });

          let options;
          if (arrayPath.length > 0) {
            options = optionsTree[arrayPath];
          } else {
            options = optionsTree;
          }

          let keys = [];
          if (options) {
            keys = Object.keys(options);
          }

          if (curWord) {
            list = keys.filter(option => {
              return regex.test(option) && option !== curWord;
            });
          } else {
            list = keys;
          }
        }

        return {
          list: list,
          from: CodeMirror.Pos(cursor.line, start),
          to: CodeMirror.Pos(cursor.line, end)
        };
      });

      CodeMirror.commands.autocomplete = function(cm) {
        CodeMirror.showHint(cm, CodeMirror.hint.highChartsHint, {
          completeSingle: false
        });
      };

      let editor;

      if (
        el instanceof HTMLElement &&
        el.tagName.toLowerCase() === "textarea"
      ) {
        editor = CodeMirror.fromTextArea(el, options);
      } else {
        editor = new CodeMirror(el, options);
      }
      el.editor = editor;

      const arrows = [37, 38, 39, 40];

      editor.on("change", () => {
        el.value = editor.getValue();
      });

      editor.on(
        "keyup",
        debounce(function(cm, e) {
          if (arrows.indexOf(e.keyCode) < 0) {
            editor.execCommand("autocomplete");
          }
        }, 300)
      );
    },
    update: function(el) {
      if (el.value !== el.editor.getValue()) {
        el.editor.setValue(el.value);
      }
    }
  });
};

export default chart;
